/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useCallback, useEffect, useContext } from 'react';
import cx from 'classnames';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { StyleRoot } from 'radium';

import './Categorias.scss';
import Modelo from '../Modelo';
import bem from '../../utils/bem';
import useIsTablet from '../useIsTablet/useIsTablet';
import { useScroll } from '../../utils/hooks';
import { ANIMATIONS, ELECTRIC_COLOR, ELECTRIC_GRADIENT } from '../../utils/constants';
import { getDescription, getMeta, getTitle, toMarcaFormatted } from '../../utils/helpers';
import { useRef } from 'react';
import DoubleArrow from '../Breadcrumbs/SVG/DoubleArrow';
import { Helmet } from 'react-helmet';
import VirtualTourContext from '../../utils/VirtualTourContext';
import {ELECTRIC_TYPE_NAME} from '../../utils/constants';
// import VirtualTourContext from '../../utils/VirtualTourContext';

const SkeletonDesktop = () => {
  return (
    <div className="categorias-skeleton">
      <div className="categorias__panel">
        <div className="categorias__panel-sidebar">
          <div
            className="categorias-skeleton__bone categorias__tile"
          />
          <div
            className="categorias-skeleton__bone categorias__tile"
          />
          <div
            className="categorias-skeleton__bone categorias__tile"
          />
          <div
            className="categorias-skeleton__bone categorias__tile"
          />
          <div
            className="categorias-skeleton__bone categorias__tile"
          />
          <div
            className="categorias-skeleton__bone categorias__tile"
          />
        </div>
        <div className="categorias__panel-content">
          <div className="categoria-detail">
            <div className="categoria-detail__content">
              <div className="categoria-detail__modelos">
                <div
                  className="categorias-skeleton__bone categoria-detail__modelo"
                />
                <div
                  className="categorias-skeleton__bone categoria-detail__modelo"
                />
                <div
                  className="categorias-skeleton__bone categoria-detail__modelo"
                />
                <div
                  className="categorias-skeleton__bone categoria-detail__modelo"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const SkeletonMobile = () => {
  return (
    <div className="categorias-skeleton">
      <div className="categorias__mobile-tiles">
        <div className="categorias__panel-sidebar">
          <div
            className="categorias-skeleton__bone categorias__tile"
          />
          <div
            className="categorias-skeleton__bone categorias__tile"
          />
          <div
            className="categorias-skeleton__bone categorias__tile"
          />
          <div
            className="categorias-skeleton__bone categorias__tile"
          />
          <div
            className="categorias-skeleton__bone categorias__tile"
          />
          <div
            className="categorias-skeleton__bone categorias__tile"
          />
        </div>
      </div>
    </div>
  );
};


const CategoriaDetail = ({ categoria }) => {
  const firstMarca =
    (categoria?.data?.marcas?.length && categoria?.data?.marcas[0]) || null;
  const [selectedMarca, setSelectedMarca] = useState(firstMarca);
  const versiones = categoria?.data?.versiones?.filter(
    version => version.marcaFiltro === selectedMarca
  );
  const [leftArrow, setLeftArrow] = useState(false);
  const [rightArrow, setRightArrow] = useState(false);
  const categoriasSectionRef = useRef(null);
  const modelosSectionRef = useRef(null);

  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    if (isMobile) {
      const scrollToModelosSection = () => {
        if (modelosSectionRef.current && categoriasSectionRef.current) {
          const categoriasRect = categoriasSectionRef.current.getBoundingClientRect();
          const modelosRect = modelosSectionRef.current.getBoundingClientRect();

          if (modelosRect.top > categoriasRect.bottom) {
            modelosSectionRef.current.scrollIntoView({ behavior: 'smooth' });
          }
        }
      };

      scrollToModelosSection();

      const addScrollFlags = () => {
        const mainNode = categoriasSectionRef.current;
        if (!mainNode) return;
        setLeftArrow(mainNode?.scrollLeft !== 0);
        setRightArrow((mainNode?.scrollLeft + mainNode?.clientWidth) !== mainNode?.scrollWidth);
      };

      if (categoriasSectionRef.current === null) {
        return;
      }
      addScrollFlags();
      categoriasSectionRef.current.addEventListener('scroll', addScrollFlags);
      return () => {
        if (categoriasSectionRef.current === null) {
          return;
        }
        categoriasSectionRef.current.removeEventListener('scroll', addScrollFlags);
      };
    }
  }, [selectedMarca]);

  useEffect(() => {
    setSelectedMarca(firstMarca);
  }, [firstMarca, categoria?.post_type]);

  return (
    <div className="categoria-detail">
      <div className={cx('categoria-detail__marcas-outer', {
        'left-arrow': leftArrow,
        'right-arrow': rightArrow
      })}>
        {window.innerWidth < 768 && (
          <>
            <div className={`mobile-inline-flex categoria-detail__marcas-leftarrow ${leftArrow ? 'categoria-detail__marcas-arrow--show':''}`}>
              <DoubleArrow color="#000"/>
            </div>
            <div className={`mobile-inline-flex categoria-detail__marcas-rightarrow ${rightArrow ? 'categoria-detail__marcas-arrow--show':''}`}>
              <DoubleArrow color="#000"/>
            </div>
          </>
        )}
        <ul className="categoria-detail__marcas" ref={categoriasSectionRef}>
          {categoria?.data?.marcas?.map(marca => (
            <li key={marca}>
              <button
                onClick={() => setSelectedMarca(marca)}
                className={cx('categoria-detail__marcas-marca', {
                  'categoria-detail__marcas-marca--selected':
                    selectedMarca === marca,
                })}
              >
                {toMarcaFormatted(marca)}
              </button>
            </li>
          ))}
        </ul>
      </div>
      
      <div className="categoria-detail__content" ref={modelosSectionRef}>
        <h3 className="categoria-detail__title">MODELOS DISPONIBLES</h3>
        <div className="categoria-detail__modelos">
          {versiones.map(modelo => (
            <Modelo key={modelo.modelo} modelo={modelo} />
          ))}
        </div>
      </div>
    </div>
  );
};

const renderTablet = (
  selectedCategoria,
  categorias,
  history,
  selectCategoria,
  match
) => {
  const categoriasData = categorias?.data || [];
  // const selectedCategoriaData = categoriasData.find(
  //   categoria => categoria.post_type === selectedCategoria?.post_type
  // );
  
  const { isLoading } = categorias;
  return (
    <div className="categorias__mobile-content">
        <h2 className="categorias__heading">Ármalo a tu manera</h2>
        <p className="categorias__subheading">
          ¡Adelante… elegí el que quieras y contáctanos!
        </p>
      <div className="categorias__mobile-tiles categorias__tiles">
        {isLoading && <SkeletonMobile columnsLength={2} />}
        {!isLoading && (
          <>
          {categorias?.extraInfo?.length && (
            <div className="categorias__panel categorias__panel--banner">
              <a href={categorias?.extraInfo[0]?.redirect} target="_blank" rel="noopener noreferrer">
                <img src={categorias?.extraInfo[0]?.imagen} alt="" />
              </a>
            </div>
          )}
          {categoriasData.map(categoria => {
            const isCategorySelected =
              categoria.post_type === selectedCategoria?.post_type;
            const isCategoryElectric = 
              categoria.post_type === ELECTRIC_TYPE_NAME;
            return (
              <StyleRoot key={categoria.post_type}>
                <button
                  className={cx('categorias__tile', {
                    'categorias__tile--selected': isCategorySelected,
                    'categorias__tile--selected_electric': (isCategoryElectric && isCategorySelected),
                  })}
                  onClick={() => {
                    if (isCategorySelected) {
                      selectCategoria(null, true);
                      return;
                    }
                    selectCategoria(categoria);
                  }}
                  style={{...ANIMATIONS.fadeIn, '--color': isCategoryElectric && ELECTRIC_GRADIENT }}
                >
                  <span
                    className="categorias__tile-icon"
                    dangerouslySetInnerHTML={{
                      __html: categoria.image_url,
                    }}
                  />
                  <p className="categorias__tile-name"
                    style={{ '--color': isCategoryElectric && ELECTRIC_COLOR }} 
                  >
                    {categoria.vehicule_type}
                  </p> 
                </button>
                {isCategorySelected && <CategoriaDetail categoria={categoria} />}
              </StyleRoot>
            );
          
          })}
          </>
        )}
      </div>
    </div>
  );
};

const renderDesktop = (
  selectedCategoria,
  categorias,
  selectCategoria,
  history,
  match,
) => (
  <div className="categorias__content">
      <h2 className="categorias__heading">Ármalo a tu manera</h2>
      <p className="categorias__subheading">
      ¡Adelante… elegí el que quieras y contáctanos!
      </p>
    <div
      className={cx('categorias__tiles', {
        'categorias__tiles--selected': true,
      })}
    >
      {categorias.isLoading ? (
        <SkeletonDesktop columnsLength={3} />
      ) : (
        <>
          {categorias?.extraInfo?.length && (
            <div className="categorias__panel categorias__panel--banner">
              <a href={categorias?.extraInfo[0]?.redirect} target="_blank" rel="noopener noreferrer">
                <img src={categorias?.extraInfo[0]?.imagen} alt="" />
              </a>
            </div>
          )}
          <div className="categorias__panel">
            <div className="categorias__panel-sidebar">
              {categorias?.data?.map((categoria, i) => {
                const isCategorySelected =
                    categoria.post_type === selectedCategoria?.post_type;
                const isCategoryElectric = 
                    categoria.post_type === ELECTRIC_TYPE_NAME;
                return (
                  <StyleRoot key={categoria.post_type}>
                    <button
                      className={cx('categorias__tile', {
                        'categorias__tile--selected': isCategorySelected,
                        'categorias__tile--selected_electric': (isCategoryElectric && isCategorySelected),
                      })}

                      onClick={() => {
                        if (isCategorySelected) {
                          return;
                        }
                        selectCategoria(categoria);
                      }}
                      style={{ ...ANIMATIONS.fadeIn, '--color': isCategoryElectric && ELECTRIC_GRADIENT}}
                      
                    >
                      <span
                        className="categorias__tile-icon"
                        dangerouslySetInnerHTML={{
                          __html: categoria.image_url,
                        }}
                      />
                      <p className="categorias__tile-name"
                        style={{ '--color': isCategoryElectric && ELECTRIC_COLOR }} 
                      >
                        {categoria.vehicule_type}
                      </p> 
                    </button>
                  </StyleRoot>);
                })}
            </div>
            <div className="categorias__panel-content">
              {selectedCategoria && (
                  <CategoriaDetail categoria={selectedCategoria} />
              )}
            </div>
          </div>
        </>
      )}
    </div>
  </div>
);

const Categorias = ({ categorias }) => {
  const match = useRouteMatch();
  const { tipo } = match.params;

  const history = useHistory();
  const scroll = useScroll();

  const virtualTourContext = useContext(VirtualTourContext);
  const { 
    hasLoadedCats,
    setHasLoadedCats,
    firstClick,
    setFirstClick } = virtualTourContext;

  const data = categorias?.data || [];
  const [selectedCategoria, setSelectedCategoria] = useState();
  const isTablet = useIsTablet();

  // const virtualTourContext = useContext(VirtualTourContext);
  // const { setIsOpen } = virtualTourContext;

  const selectCategoria = useCallback(
    (categoria, preventToContinue) => {
      setHasLoadedCats(true);
      setSelectedCategoria(selectedCategoria === categoria ? null : categoria);
      if (preventToContinue) {
        return;
      }
      scroll('.categorias__tiles');
      if (tipo) {
        if (!firstClick && isTablet) {
          setFirstClick(true);
          return;
        }
        if (tipo === categoria.post_type) {
          history.push('/');
        } else {
          history.push(`/${categoria.post_type}/`);
        }
      } else {
        history.push(`${match.url}${categoria.post_type}/`);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedCategoria, scroll, tipo, history, match.url]
  );


  useEffect(() => {
    if (data.length === 0) {
      return;
    }
    if (!hasLoadedCats) {
      setHasLoadedCats(true);
      if (isTablet) {
        return;
      }
    }
    setSelectedCategoria(data.find(categoria => categoria.post_type === tipo));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, tipo]);

  // console.log(selectedCategoria);
  const getBrandInfo = () => {
    const { selectedBrand } = categorias;
    if (!selectedBrand) return categorias?.brands?.default;

    const brand = Object.keys(categorias.brands).find(
      b => b === selectedBrand.toLowerCase()
    );

    return brand ? categorias.brands[brand] : categorias.brands.default;
  };
  const meta = getMeta(tipo);
  const title = getTitle(tipo);
  const description = getDescription(tipo);

  return (
    <div
      className={'gradient ' + bem('categorias', { 'detail-mode': !!selectedCategoria })}
      style={{ '--color': getBrandInfo().color }}
    >
      <Helmet> 
        {title && <title>{title}</title>}
        {meta && <meta name="keywords" content={meta} />}
        {description && <meta name="description" content={description} />}
      </Helmet>
      {getBrandInfo().image && (
        <div className="categorias__logo">
          <img src={getBrandInfo().image} alt="logo" />
        </div>
      )}
      {isTablet
        ? renderTablet(
            selectedCategoria,
            categorias,
            history,
            selectCategoria,
            match
          )
        : renderDesktop(
            selectedCategoria,
            categorias,
            selectCategoria,
            history,
            match
          )}
      <div className="categorias__row1">
        <div>
          <h1 className="categorias__title">
            ¿Cómo comprar un carro de agencia?
          </h1>
          <p className="categorias__subtitle">
          ¡Comprar carro en Costa Rica es sencillo con Veinsa! <br />
          Te decimos como tener tu chuzo desde casa, dar click <a href="https://youtu.be/DB2Rfot3qiw" target="_blank" rel="noopener noreferrer">aquí</a>
          </p>
        </div>
      </div>
    </div>
  );
};
export default Categorias;
